import styled from 'styled-components'

export const ModalFooter = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`
